import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Participant } from '../models/participant.model';
import { ParticipantSummary } from '../models/participant-summary.model';

@Injectable({ providedIn: 'root' })
export class ParticipantService {
  private readonly http = inject(HttpClient);

  getById(participantId: string): Observable<Participant> {
    const url = `/api/v1/participants/${participantId}`;
    return this.http.get<Participant>(url);
  }

  getParticipantsForSigning(
    signingId: string,
  ): Observable<ParticipantSummary[]> {
    const url = `/api/v1/signings/${signingId}/participants`;
    return this.http.get<ParticipantSummary[]>(url);
  }
}
